
import React from 'react';
import { motion } from 'framer-motion';
import { PredictionChartData } from './types';
import { PredictionMetrics } from './PredictionMetrics';
import { PredictionLineChart } from './PredictionLineChart';
import { PredictionScenarios } from './PredictionScenarios';

interface PredictionChartProps {
  data: PredictionChartData;
}

export function PredictionChart({ data }: PredictionChartProps) {
  const metalColor = data.metal === 'ORO' ? 'border-l-gold' : 'border-l-silver';
  const metalBg = data.metal === 'ORO' ? 'bg-gold/5' : 'bg-silver/5';
  
  return (
    <motion.div 
      className={`space-y-8 border-l-4 ${metalColor} pl-6 py-6 ${metalBg} rounded-r-xl`}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <PredictionMetrics
        metal={data.metal}
        currentPrice={data.currentPrice}
        targetPrice={data.targetPrice}
        targetPercentage={data.targetPercentage}
        timeframe={data.timeframe}
        confidence={data.confidence}
      />
      
      <motion.div 
        className="bg-card rounded-xl border-2 border-border/50 p-6 shadow-lg"
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-xl font-bold text-foreground">
            Andamento {data.metal} - {data.timeframe}
          </h3>
          <div className="text-sm text-muted-foreground">
            Affidabilità: {data.confidence}%
          </div>
        </div>
        
        <PredictionLineChart
          metal={data.metal}
          timeSeries={data.timeSeries}
          currentPrice={data.currentPrice}
        />
        
        <div className="mt-6 grid grid-cols-2 lg:grid-cols-4 gap-4 text-sm">
          <div className="flex items-center gap-2 text-muted-foreground">
            <div className="w-4 h-1 bg-current rounded"></div>
            <span>Dati storici</span>
          </div>
          <div className="flex items-center gap-2 text-muted-foreground">
            <div className="w-4 h-1 border-dashed border-t-2 border-green-400"></div>
            <span>Scenario Alto</span>
          </div>
          <div className="flex items-center gap-2 text-muted-foreground">
            <div className="w-4 h-1 border-dashed border-t-2 border-yellow-400"></div>
            <span>Scenario Medio</span>
          </div>
          <div className="flex items-center gap-2 text-muted-foreground">
            <div className="w-4 h-1 border-dashed border-t-2 border-red-400"></div>
            <span>Scenario Basso</span>
          </div>
        </div>
      </motion.div>
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.4 }}
      >
        <PredictionScenarios
          metal={data.metal}
          scenarios={data.scenarios}
        />
      </motion.div>
    </motion.div>
  );
}
